<template>
  <div>
    <h3 class="title">Medical Machine Usages</h3>
    <div class="ui segment" v-if="Object.keys(medicalMachineUsages).length">
      <div 
        v-for="packageId in Object.keys(medicalMachineUsages)" 
        :key="packageId" 
      >
        <h3>{{ medicalMachineUsages[packageId].p.name }}</h3>
        <abstractTable 
          :columns="usagesColumns" 
          :data="formattedUsages(medicalMachineUsages[packageId].details)"
          :classes="'ui very compact center aligned celled table'"
        />
      </div>
    </div>
    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          There is No medical machine usages for this visit
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    medicalMachineUsages: { type: Object, required: true }
  },
  computed: {
    usagesColumns () {
      return [
        { header: 'Service', fieldName: 'service', show: true },
        { header: 'Pulses', fieldName: 'quantity', show: true },
        { header: 'Power 1', fieldName: 'power1', show: true },
        { header: 'Power 2', fieldName: 'power2', show: true },
        { header: 'Skin type', fieldName: 'skinType', show: true },
        { header: 'Cooling', fieldName: 'cooling', show: true },
        { header: 'Note', fieldName: 'note', show: true }
      ]
    }
  },
  methods: {
    formattedUsages(usages) {
      return usages.map(usage => ({
        ...usage,
        service: this.VisitServices[usage.service_id]
      }))
    }
  },
}
</script>

<style scoped>
  .title {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/visit_history_components/MedicalMachineUsage.vue